module.exports = __webpack_public_path__ + "img/personel-5.png";